export const getFilteredArrFromStr = (a, b) => {
  if (!b?.length) return a;
  const arrayA = a.split(',');
  const arrayB = b.split(',');

  const resultArray = arrayA.filter((item) => !arrayB.includes(item));
  return resultArray.join(',');
};
